import ADIProductSaleInfo , { TagsStyles } from "@NA/Components/ProductList/ADIProductSaleInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    HasProduct,
    HasProductContext,
    withProduct,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { isPriceAvailable } from "@NA/Utils/Utility";

type OwnProps = WidgetProps & HasProductContext & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context.session!.isAuthenticated,
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ADIStickyCartPriceStyles {
    productPrice?: ProductPriceStyles;
    pricingMainWrapper?: InjectableCss;
    dollarSymbol?: InjectableCss;
    dollarNumber?: InjectableCss;
    centNumber?: InjectableCss;
    unitofMeasureText?: InjectableCss;
    pdpTagStyles?: TagsStyles;
}

export const adiStickyCartPriceStyles: ADIStickyCartPriceStyles = {
    productPrice: {
        price: {
            priceText: {
                css: css`
                    flex-direction: row;
                    flex-wrap: wrap;
                    display: flex;
                    color: ${getColor("text.main")};
                    font-weight: 900;
                    ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        margin-top: 0px;
                                    `,
                                    null,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    sup {
                        font-size: 20px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        font-size: 9px;
                                    `,
                                    null,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }
                    sup:first-child {
                        display: inline-block;
                        margin-top: 2px;
                        margin-right: -1px;
                        line-height: 20px;
                        font-weight: 900;
                        font-stretch: normal;
                        font-style: normal;
                        color: ${getColor("text.main")};
                    }
                    span {
                        font-size: 40px;
                        font-weight: 900;
                        display: block;
                        color: ${getColor("text.main")};
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-size: 14px;
                                        margin: -3px 1px 0px 1px;
                                    `,
                                    css`
                                        font-size: 14px;
                                        margin: -3px 1px 0px 1px;
                                    `,
                                    css`
                                        font-size: 36px;
                                    `,
                                    null,
                                    null,
                                ],
                            )}
                    }
                    sup:last-child {
                        margin-left: 0px;
                        line-height: normal !important;
                        @media only screen and (max-width: 1080px) {
                            line-height: inherit !important;
                        }
                    }
                `,
            },
        },
    },
    pricingMainWrapper: {
        css: css`
            display: inline-flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            justify-content: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            justify-content: start;
                        `,
                    css`
                                justify-content: start;
                            `,
                            css`
                            justify-content: start;
                        `,
                        css`
                        justify-content: start;
                    `,
                    css`
                        padding-top: 30px;
                    `,
                ])}
            >div[class^="sc"] {
                position: unset;
                margin-right: 0px;
                margin-top: -7px;
                // @media only screen and (min-width: 768px) and (max-width: 1080px){
                //     margin-top: -7px;
                //   }
                @media only screen and (max-width: 767px) {
                    margin-top: -7px;
                  }
                ${TypographyStyle}{
                    margin-right: 6px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-top: -3px;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
                >${TypographyStyle} {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    font-size: 10px;
                                    padding: 0 15px;
                                    min-height: 17px;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
            > section[class^="sc"] {
                width: unset;
                gap: 0px;
                @media only screen and (min-width: 768px) and (max-width: 1080px) {
                    margin-top: -7px;
                }
                @media only screen and (max-width: 767px) {
                    margin-top: -7px;
                }
                > div[class^="sc"] {
                    &:last-child {
                        margin-left: 6px;
                        margin-top: -7px;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css` 
                                    margin-left: 0px; 
                                    margin-top: 0px;
                                `,
                                css` 
                                    margin-left: 0px; 
                                    margin-top: 0px;
                                `,
                                css` 
                                    margin-left: 0px; 
                                    margin-top: 0px;//temp
                                `,
                                null,
                                null,
                            ],
                        )}
                        > ${TypographyStyle} {
                            font-size: 14px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            font-size: 12px;
                                            margin-top: 0px;
                                            line-height: .9;
                                            padding-top: 8px;
                                        `,
                                        css`
                                            font-size: 12px;
                                            margin-top: 0px;
                                            line-height: .9;
                                            padding-top: 8px;
                                        `,
                                        css`
                                            font-size: 12px;
                                            margin-top: -3px;
                                            line-height: .9;
                                            padding-top: 8px;
                                        `,
                                        null,
                                        null,
                                    ],
                                )}
                                + ${TypographyStyle} {
                                    ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            padding-top: 2px;
                                            padding-bottom: 2px;
                                        `,
                                        css`
                                            padding-top: 2px;
                                            padding-bottom: 2px;
                                        `,
                                        css`
                                            padding-top: 8px;
                                            padding-bottom: 2px;
                                        `,
                                        null,
                                        null,
                                    ],
                                )}
                                }
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin: 5px 0px 0px !important;
                        `,
                        null,
                        css`
                            margin: 15px 0px 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    pdpTagStyles: {
        tagsContainer: {
            css: css`
                position: static;
                margin-right: 10px;
            `,
        },
    },
};

const styles = adiStickyCartPriceStyles;

const ADIStickyCartPrice: React.FC<OwnProps> = ({ productContext, product, isAuthenticated, productSettings }) => {
    const pricingIsAvailable = isPriceAvailable(
        productContext.productInfo.pricing,
        productContext.productInfo.qtyOrdered,
    );
    const pricing = productContext.productInfo?.pricing || product.pricing;
    return (
        <>
            {isAuthenticated && pricingIsAvailable && (
                <StyledWrapper {...styles.pricingMainWrapper}>
                    <ADIProductSaleInfo product={product} isAuthenticated={isAuthenticated} pricing={pricing} extendedStyles={styles.pdpTagStyles} />
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.productPrice}
                    />
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(withProductContext(ADIStickyCartPrice))),
    definition: {
        group: "Common",
        displayName: "ADI Sticky Cart Price",
    },
};

export default widgetModule;
